import { Button  } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';
import type { Route } from 'next';
import Link from 'next/link';
import type { PropsWithChildren } from 'react';

type LinkButtonProps<T extends string> = ButtonProps & {
	href:      Route<T>
	isNewTab?: boolean
};

export const NextLinkButton = <T extends string>({
	children,
	href,
	...buttonProps
}: PropsWithChildren<LinkButtonProps<T>>) => {
	const newTabProps = {
		rel:    'noopener noreferrer',
		target: '_blank',
	};

	return (
		<Button asChild {...buttonProps}>
			<Link href={href} {...(buttonProps.isNewTab ? newTabProps : {})}>
				{children}
			</Link>
		</Button>
	);
};
